/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SegmentResponse } from '../../models/segment-response';

export interface GetSegment$Params {
  'Active-Tenant-Identifier': string;
  segmentId: string;
}

export function getSegment(http: HttpClient, rootUrl: string, params: GetSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<SegmentResponse>> {
  const rb = new RequestBuilder(rootUrl, getSegment.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('segmentId', params.segmentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SegmentResponse>;
    })
  );
}

getSegment.PATH = '/segments/{segmentId}';
